import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    "name": "salesstatus",
    standalone: true
})
export class SalesStatusPipe implements PipeTransform {
    transform (value: number): string {
        switch (value) {
            case 0:
                return "Sold";
            case 1:
                return "Available";
            case 2:
                return "Unavailable";
            case 3:
                return "Closed";
            case 4:
                return "Pending Release";
            case 5:
                return "Pending Sale";
            case 6:
                return "Spec";
            case 7:
                return "Model";
            case 8:
                return "Spec Unavailable";
            default:
                return "";
        }
    }
}
